import { render, staticRenderFns } from "./ShiftAssignmentsTab.vue?vue&type=template&id=eba12d12&scoped=true"
import script from "./ShiftAssignmentsTab.vue?vue&type=script&lang=js"
export * from "./ShiftAssignmentsTab.vue?vue&type=script&lang=js"
import style0 from "./ShiftAssignmentsTab.vue?vue&type=style&index=0&id=eba12d12&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eba12d12",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eba12d12')) {
      api.createRecord('eba12d12', component.options)
    } else {
      api.reload('eba12d12', component.options)
    }
    module.hot.accept("./ShiftAssignmentsTab.vue?vue&type=template&id=eba12d12&scoped=true", function () {
      api.rerender('eba12d12', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/flow/attendances/settings/components/ShiftAssignmentsTab.vue"
export default component.exports